import Footer from './Footer';
import Header from './Header';
import MainYaba from './Main/MainYaba';

function ContoYaba (params) {
    
    return(
        <div>
            <Header />
            <MainYaba />
            <Footer />
        </div>
    );
}

export default ContoYaba;
